import {createActionWithoutPayload, createActionWithPayload} from "../../utils.actions";
import {ArticleOnlinePublicationTask} from "../../../../types/article";

export const [fetchOnlinePublications, isFetchOnlinePublicationsAction] = createActionWithoutPayload('FETCH_ONLINE_PUBLICATIONS')
export const [fetchOnlinePublicationsResponse, isFetchOnlinePublicationsResponseAction] = createActionWithPayload<ArticleOnlinePublicationTask[] | undefined>('FETCH_ONLINE_PUBLICATIONS_RESPONSE')

export const [deleteOnlinePublications, isDeleteOnlinePublicationsAction] = createActionWithPayload<ArticleOnlinePublicationTask>('DELETE_ONLINE_PUBLICATIONS')

export const [pushArticlesOnlineNowAction, isPushArticlesOnlineNowAction] = createActionWithPayload<ArticleOnlinePublicationTask>('PUSH_ARTICLES_ONLINE_NOW');
